<template>
  <div>
    <div>
       <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading
        :active.sync="isLoading"
        loader="spinner"
        color="#36304a"
        :width="70"
      ></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="
            border-radius: 5px !important;
            padding-left: 0px;
            height: auto !important;
          "
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-brand center>Overseas Agent Assignments</b-navbar-brand>
          <b-navbar-nav class="ml-auto" center>
            <b-nav-form>
              <!-- v-if="$sessionsStorage.get('designation') == 'Admin' && $sessionsStorage.get('nameUser') == 'Bhavneesh'" -->
              <!-- <b-button
              style="margin-top: 20px"
              size="sm"
              class="ml-3"
              @click="getReports('OVERSEAS_SCREEN','0', '1', '1')"
              variant="outline-info"
              >Export as Excel</b-button
            > -->
              <!-- <b-button
                size="sm"
                class="mr-3 mb-1"
                @click="getReports('OVERSEAS_SCREEN_ALL', '0', '1', '1')"
                variant="outline-info"
                >Export Overseas Assignment
              </b-button> -->
              <b-button
                :disabled="ExcelBtnName != 'Export Overseas Assignment' ? true : false"
                class="mr-3 mb-1"
                @click="
                  getReports(
                    'OVERSEAS_SCREEN_ALL',
                    '0',
                    '1',
                    '1',
                    'Export Overseas Assignment'
                  )
                "
                size="sm"
                variant="outline-info"
                >{{ ExcelBtnName }}
                <b-spinner
                  v-if="ExcelBtnName != 'Export Overseas Assignment'"
                  small
                  label="Small Spinner"
                ></b-spinner
              ></b-button>
              <Filter-Agency-Modal />
              <FilterCBModal />
              <ClientCard />
               <ShipmentTrackCard />
            </b-nav-form>
          </b-navbar-nav>
        </b-navbar>

        <div class="row">
          <div class="col-md-4">
            <b-form-group style="margin-bottom: 0 !important">
              <b-input-group>
                <b-form-input
                  :formatter="capitalizeAll"
                  v-model="filter"
                  @input="debounceSearch"
                  placeholder="Type To Search (Assignment No. / Client / Container No. / Shipping BL No / SHipping Invoice No / MBL / HBL )"
                />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </div>
          <b-col class="col-md-3">
            <label for="blType">To</label>
            <model-list-select
              :list="$store.getters['common/getAllAgentColoaderList']"
              option-value="agentName"
              option-text="agentName"
              v-model="ToFilter"
              placeholder="Select To"
              @input="viewFFExportFCL('0', '0', '1', '1')"
            ></model-list-select>
          </b-col>
            <b-col class="col-md-3">
            <label for="blType">Agent</label>
            <model-list-select
              :list="$store.getters['commonDropdownMaster/getAllAgentDDList']"
              option-value="value"
              option-text="text"
              v-model="agentFilter"
              placeholder="Select Agent"
              @input="viewFFExportFCL('0', '0', '1', '1')"
            ></model-list-select>
          </b-col>
          <b-col class="col-md-3">
            <label for="blType">Incoterm</label>
            <model-list-select @input="viewFFExportFCL('0', '0', '1', '1')" :list="deliveryTermsList" v-model="termFilter" option-value="value"
            option-text="text" placeholder="Select Incoterm"  />
          </b-col>
          <div class="col-md-2">
            <label>BL FILTER</label>
            <model-list-select
              @input="viewFFExportFCL('0', '0', '1', '1')"
              :list="blNoStatusList"
              v-model="billingFilter"
              option-value="inv"
              option-text="int"
              placeholder="Select Status"
            ></model-list-select>
          </div>
          <div class="col-md-2">
            <label>CLOSE STATUS</label>
            <model-list-select
              @input="viewFFExportFCL('0', '0', '1', '1')"
              :list="CLosedStatusList"
              v-model="closedFilter"
              option-value="inv"
              option-text="int"
              placeholder="Select Close Status"
            ></model-list-select>
          </div>
          <div class="col-md-2">
            <label>MANIFESTATION STATUS</label>
            <model-list-select
              @input="viewFFExportFCL('0', '0', '1', '1')"
              :list="ManifestationStatusList"
              v-model="manifestationFilter"
              option-value="inv"
              option-text="int"
              placeholder="Select Manifestation"
            ></model-list-select>
          </div>
          <div class="col-md-2">
            <label>SOB FILTER</label>
            <model-list-select
              @input="viewFFExportFCL('0', '0', '1', '1')"
              :list="SOBStatusList"
              v-model="SOBFilter"
              option-value="inv"
              option-text="int"
              placeholder="Select SOB Status"
            ></model-list-select>
          </div>
        </div>
        <div class="mt-2">
          <h5 class="text-muted pull-right">
            <small v-if="isLoading == false">{{ totalRows }} Entries</small>
          </h5>
        </div>

        <!-- Main table element -->
        <div class="table-responsive tableMain">
          <b-table
            show-empty
            stacked="md"
            :items="FFExport"
            :fields="fields"
            :per-page="perPage"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
          >
            <template slot="isFFExportActive" slot-scope="row0">
              <span>{{ row0.index + 1 + (currentPage - 1) * perPage }}</span>
            </template>
            <template slot="ffExportFclSeries" slot-scope="row11">
              <div
                class="text-left"
                :style="row11.item.seenExec == '0' ? 'color:black' : 'color:black'"
              >
                <!--  -->
                <div
                  :style="row11.item.seenExec == '0' ? 'color:black' : 'color:black'"
                  @click="
                    row11.item.is_locked == '1' &&
                    (row11.item.finalBillingCompleted == 1 ||
                      row11.item.locked_counter > 0)
                      ? ''
                      : viewExportFCLPage(row11.item)
                  "
                  class="showMoreData"
                >
                  <!-- @click="row11.item.finalBillingCompleted == 0?viewExportFCLPage(row11.item):''" -->
                  <!-- <b-badge v-if="row11.item.seenExec == '0'" variant="danger"
                    >New
                    <br />
                  </b-badge> -->

                  <span
                    ><b>{{ row11.item.ffExportFclSeries }}</b></span
                  >
                  <br />
                  <span>Assignment Dt. : {{ row11.item.loginTime | moment }}</span>
                  <br />
                  <span>Raised From : {{ row11.item.raisedFrom }}<br /></span>
                  <span>By : {{ row11.item.raisedBy }}<br /></span>
                  <span v-if="row11.item.enquiry_booking_no">BRF No : {{ row11.item.enquiry_booking_no }}<br /></span>
                  <span v-if="row11.item.inco_term">Inco Term : {{ row11.item.inco_term }}<br /></span>
                  
                  
                  <b :style="'color:black'">Billing : </b>
                <b-badge variant="success" v-if="(row11.item.finalBillingCompleted == '1')">Billing Completed</b-badge>
                <b-badge v-else-if="row11.item.finalBillingCompleted == '4'" variant="success">Billing Completed - Agent Expense Pending</b-badge>
                <b-badge v-else variant="danger">Billing In-complete</b-badge><br/>
                  <!-- <span v-if="row11.item.finalBillingCompleted == '1'"
                    ><b :style="'color:black'">Billing : </b>
                    <b-badge variant="success"><b>Completed</b></b-badge
                    ><br
                  /></span>
                  <span v-if="row11.item.finalBillingCompleted == '0'"
                    ><b :style="'color:black'">Billing : </b>
                    <b-badge variant="danger"><b>Pending</b></b-badge
                    ><br
                  /></span> -->
                  <b-button
                    style="font-size: 0.675rem"
                    class="mt-2"
                    size="sm"
                    @click="
                      row11.item.is_locked == '1' &&
                      (row11.item.finalBillingCompleted == 1 ||
                        row11.item.locked_counter > 0)
                        ? LockUnLock(row11.item, 'locked')
                        : ''
                    "
                    :variant="
                      row11.item.is_locked == '1' &&
                      (row11.item.finalBillingCompleted == 1 ||
                        row11.item.locked_counter > 0)
                        ? 'danger'
                        : 'success'
                    "
                    ><b
                      v-if="
                        row11.item.is_locked == '1' &&
                        (row11.item.finalBillingCompleted == 1 ||
                          row11.item.locked_counter > 0)
                      "
                      ><i class="fa fa-lock mr-1 lg"></i>LOCKED</b
                    ><b v-else><i class="fa fa-unlock mr-1 lg"></i>UN-LOCKED</b></b-button
                  ><br />
                  <span
                    v-if="
                      row11.item.sob_date_detected != '' &&
                      row11.item.sob_date_detected != null
                    "
                    ><b :style="'color:black'"
                      ><br />SOB : {{ row11.item.sob_date_detected }}</b
                    >
                    <b-badge variant="danger"><b>SAILED</b></b-badge></span
                  >
                </div>
                <RejectInvTallyBillSummary
                    v-if="row11.item.allModuleId"
                    :PMC_title="'Invoice Rejection Log Summary Job No - ' + row11.item.ffExportFclSeries"
                    :PMC_JOBID="row11.item.allModuleId.toString()"
                    :PMC_JOBNO="row11.item.ffExportFclSeries"
                    :PMC_JOBDATE="''"
                    :PMC_JOBTYPE="''"
                    :PMC_Client="''"
                    :PMC_Sline="''"
                  />
                <b-button
                  class="mt-2"
                  style="font-size: 0.675rem"
                  size="sm"
                  @click="showDocModal(row11.item)"
                  variant="outline-info"
                  >Summary & Documents</b-button
                >
                <Assignment-Summary
                  :title="'Shipment Summary Tracking - '"
                  :fk_all_module_id="row11.item.allModuleId"
                  :jb_series="row11.item.ffExportFclSeries"
                />
                <ContainerSummary
                  v-if="row11.item.allModuleId"
                  :PMC_title="
                    'Container Summary Job No - ' + row11.item.ffExportFclSeries
                  "
                  :PMC_JOBID="row11.item.allModuleId"
                  :PMC_JOBNO="row11.item.ffExportFclSeries"
                  :PMC_JOBDATE="''"
                  :PMC_JOBTYPE="''"
                  :PMC_AgentType="''"
                  :PMC_Client="''"
                  :PMC_Sline="''"
                />
                <!-- <JobWisePaymentsDetails
                  v-if="row11.item.allModuleId"
                  :allModuleId="Number(row11.item.allModuleId)"
                  :JobNo="row11.item.ffExportFclSeries"
                  /> -->
                <br />
                <h7
                  class="mt-2"
                  v-if="
                    row11.item.toSplitAssignmentNo && row11.item.newContainerFlow == '1'
                  "
                  ><b-badge variant="info"
                    >Split of {{ row11.item.toSplitAssignmentNo }}</b-badge
                  >
                </h7>
              </div>
            </template>
            <template slot="newfreightContainers" slot-scope="row5">
              <div v-if="row5.item.newContainerFlow == '1'">
                <div class="text-left" v-if="row5.item.newfreightContainers">
                  <div v-if="row5.item.newfreightContainers">
                    <span
                      v-for="(item1, index) in row5.item.newfreightContainers.split(',')"
                      :key="index"
                    >
                      <h6>
                        <b-badge variant="light"
                          >{{ item1 == "" ? "-------" : item1 }}
                        </b-badge>
                      </h6>
                    </span>
                  </div>
                </div>
                <div class="text-left" v-else>
                  <b-badge variant="light">-------</b-badge>
                </div>
              </div>
              <div v-if="row5.item.newContainerFlow == '0'">
                <div class="text-left" v-if="row5.item.freightContainers">
                  <div v-if="row5.item.freightContainers">
                    <span
                      v-for="(item1, index) in row5.item.freightContainers.split(',')"
                      :key="index"
                    >
                      <h6>
                        <b-badge variant="light"
                          >{{ item1 == "" ? "-------" : item1 }}
                        </b-badge>
                      </h6>
                    </span>
                  </div>
                </div>
                <div class="text-left" v-else>
                  <b-badge variant="light">-------</b-badge>
                </div>
              </div>
            </template>

            <template slot="newShipperInv" slot-scope="row56">
              <div v-if="row56.item.newContainerFlow == '1'">
                <div class="text-left" v-if="row56.item.newShipperInv">
                  <div v-if="row56.item.newShipperInv">
                    <span
                      v-for="(item1, index) in row56.item.newShipperInv.split(',')"
                      :key="index"
                    >
                      <h6>
                        <b-badge variant="light"
                          >{{ item1 == "" ? "-------" : item1 }}
                        </b-badge>
                      </h6>
                    </span>
                  </div>
                </div>
                <div class="text-left" v-else>
                  <b-badge variant="light">-------</b-badge>
                </div>
              </div>
              <div v-if="row56.item.newContainerFlow == '0'">
                <div class="text-left" v-if="row56.item.shipperInvNo">
                  <div v-if="row56.item.shipperInvNo">
                    <span
                      v-for="(item1, index) in row56.item.shipperInvNo.split(',')"
                      :key="index"
                    >
                      <h6>
                        <b-badge variant="light"
                          >{{ item1 == "" ? "-------" : item1 }}
                        </b-badge>
                      </h6>
                    </span>
                  </div>
                </div>
                <div class="text-left" v-else>
                  <b-badge variant="light">-------</b-badge>
                </div>
              </div>
            </template>

            <template slot="newSB" slot-scope="row564">
              <div v-if="row564.item.newContainerFlow == '1'">
                <div class="text-left" v-if="row564.item.newSB">
                  <div v-if="row564.item.newSB">
                    <span
                      v-for="(item1, index) in row564.item.newSB.split(',')"
                      :key="index"
                    >
                      <h6>
                        <b-badge variant="light"
                          >{{ item1 == "" ? "-------" : item1 }}
                        </b-badge>
                      </h6>
                    </span>
                  </div>
                </div>
                <div class="text-left" v-else>
                  <b-badge variant="light">-------</b-badge>
                </div>
              </div>
              <div v-if="row564.item.newContainerFlow == '0'">
                <div class="text-left" v-if="row564.item.shippingBillNo">
                  <div v-if="row564.item.shippingBillNo">
                    <span
                      v-for="(item1, index) in row564.item.shippingBillNo.split(',')"
                      :key="index"
                    >
                      <h6>
                        <b-badge variant="light"
                          >{{ item1 == "" ? "-------" : item1 }}
                        </b-badge>
                      </h6>
                    </span>
                  </div>
                </div>
                <div class="text-left" v-else>
                  <b-badge variant="light">-------</b-badge>
                </div>
              </div>
            </template>

            <template slot="POR" slot-scope="row10">
              <span
                >Stuffing :-
                {{
                  row10.item.stuffingType == "warehouseStuffing"
                    ? "WAREHOUSE"
                    : "FACTORY"
                }}<br
              /></span>
               <span>
                  Agent Name : {{ row10.item.agentName }}
                  <br />
                </span>
              <span>S-Line :- {{ row10.item.shippingLine }}</span>
              <br />
              <span>POR :- {{ row10.item.POR }}</span>
              <br />
              <span>LP :- {{ row10.item.LP }}</span>
              <br />
              <span>POD :- {{ row10.item.POD }}</span>
              <br />
              <span>FPOD :- {{ row10.item.FPOD }}</span>
              <br />
              <span>Booking No. :- {{ row10.item.validBookingNo }}</span>
              <br />
            </template>

            <template slot="MBL" slot-scope="row18">
              <span>MBL NO.:- {{ row18.item.master_linerBLNumber }}<br /></span>
              <span>HBL NO.:- {{ row18.item.house_BLNumber }}<br /></span>
              <span
                 v-if="row18.item.newfreightContainers"><b>CONT NO.:-</b> {{ wordWrap(row18.item.newfreightContainers, 24) }}<br
              /></span>
              <span
                 v-if="row18.item.containersTypes"><b>CONT TYPE.:-</b> {{ wordWrap(row18.item.containersTypes, 24) }}</span
              >
              <br />
            </template>

            <template slot="action" slot-scope="row3">
              <!-- {{row3.item.closedOverseas_status}} -->
              <b-button
                class="mb-1"
                v-if="row3.item.debitcount >= 1"
                :disabled="row3.item.closedOverseas_status == 0 ? true : false"
                @click="
                  row3.item.CountmainManifestationData > 0
                    ? openNoteModal(2, row3.item)
                    : ''
                "
                size="sm"
                variant="outline-success"
                >Debit Note</b-button
              >
              <!-- row3.item.CountmainManifestationData > 0
                    ? openNoteModal(2, row3.item)
                    : '' -->
              <b-button
                class="mb-1"
                v-if="row3.item.debitcount <= 0"
                :disabled="row3.item.closedOverseas_status == 0 ? true : false"
                @click="
                  row3.item.CountmainManifestationData > 0
                    ? openNoteModal(2, row3.item)
                    : ''
                "
                size="sm"
                variant="outline-danger"
                >Debit Note</b-button
              >
              <b-button
                v-if="row3.item.creditcount >= 1"
                :disabled="row3.item.closedOverseas_status == 0 ? true : false"
                class="mb-1"
                @click="
                  row3.item.CountmainManifestationData > 0
                    ? openNoteModal(1, row3.item)
                    : ''
                "
                size="sm"
                variant="outline-success"
                >Credit Note</b-button
              >
              <!-- row3.item.CountmainManifestationData > 0
                    ? openNoteModal(1, row3.item)
                    : '' -->
              <b-button
                :disabled="row3.item.closedOverseas_status == 0 ? true : false"
                v-if="row3.item.creditcount <= 0"
                class="mb-1"
                @click="
                  row3.item.CountmainManifestationData > 0
                    ? openNoteModal(1, row3.item)
                    : ''
                "
                size="sm"
                variant="outline-danger"
                >Credit Note</b-button
              >

              <b-button
                v-if="!row3.item.preAlertDate"
                @click="checkActions(row3.item)"
                size="sm"
                variant="outline-danger"
                >Send Pre-Alert</b-button
              >
              <div v-else>
                <br />
                <b-badge class="p-2" variant="success"
                  ><b>PreAlert sent on {{ row3.item.preAlertDate }} </b> <br /><br />
                  <b>by {{ row3.item.preAlertRaisedBy }} </b>
                </b-badge>
              </div>
              <b-button
                v-if="
                  row3.item.frghtTermsMbl == 'Collect' &&
                  row3.item.frghtTermsHbl == 'Collect' &&
                  row3.item.closedOverseas_status == 1 &&
                  row3.item.creditDebitNoteType != 1 &&
                  row3.item.creditDebitNoteType != '' &&
                  !checkcreditDebitNote_Status(row3.item.NoteDetails)
                "
                variant="warning"
                @click="checkActions(row3.item)"
                size="sm"
                >Credit Note Pending
                <br />
              </b-button>

              <!-- <b-button
               v-if="!row3.item.creditDebitNoteType"
                @click="checkActions(row3.item)"
                size="sm"
                variant="outline-danger"
              >Debit / Credit Note</b-button> -->

              <div>
                <br />
                <span v-for="(CDitem, CD_index) in row3.item.NoteDetails" :key="CD_index">
                  <b-badge
                    class="p-2 ml-2"
                    variant="warning"
                    :creditNoteStatus="CDitem.creditDebitNote_Status"
                    v-if="
                      CDitem.uploadCreditDebit != '' &&
                      CDitem.approvalStatus == '1' &&
                      CDitem.creditDebitNoteType == '1'
                    "
                    @click="
                      PrintNote(row3.item.ffExportFclSeries, CDitem.uploadCreditDebit)
                    "
                    size="sm"
                    ><span v-if="CDitem.creditDebitNoteType == '1'"
                      >Credit Note PDF</span
                    ></b-badge
                  >

                  <b-badge
                    class="p-2"
                    variant="warning"
                    v-if="
                      CDitem.uploadCreditDebit != '' &&
                      CDitem.approvalStatus == '1' &&
                      CDitem.creditDebitNoteType == '2'
                    "
                    @click="
                      PrintNote(row3.item.ffExportFclSeries, CDitem.uploadCreditDebit)
                    "
                    size="sm"
                  >
                    <span v-if="CDitem.creditDebitNoteType == '2'">Debit Note </span
                    >PDF<br
                  /></b-badge>
                </span>

                <b-badge class="p-2 mt-1" variant="success"
                  ><b>Debit / Credit Generated on {{ row3.item.creditDebitTime }}</b>
                  <br />
                </b-badge>
              </div>

              <br />
              <b-button
                v-if="row3.item.portLocationType == 'USA' && !row3.item.amsTime"
                @click="checkActions(row3.item)"
                size="sm"
                variant="outline-danger"
                >AMS Filed</b-button
              >
              <b-badge
                v-else-if="row3.item.portLocationType == 'USA' && row3.item.amsTime"
                variant="info"
                >AMS on {{ row3.item.amsTime }}
                <br />
              </b-badge>

              <b-button
                v-if="row3.item.portLocationType == 'USA' && !row3.item.isfTime"
                @click="checkActions(row3.item)"
                size="sm"
                variant="outline-danger"
                >ISF Filed</b-button
              >
              <b-badge
                v-else-if="row3.item.portLocationType == 'USA' && row3.item.amsTime"
                variant="info"
                >ISF on {{ row3.item.isfTime }}
                <br />
              </b-badge>
              <br />
            </template>
            <template slot="eta_details" slot-scope="row321">
              <span v-if="row321.item.ETA_destination_estimated != ''"
                >Tentative : {{ row321.item.ETA_destination_estimated }}</span
              >
              <span v-if="row321.item.ETA_destination_actual != ''"
                ><br />Actual : {{ row321.item.ETA_destination_actual }}</span
              >
            </template>
            <template slot="manifestation" slot-scope="row3">
              <!-- {{row3.item.fclAlertId}} --> 
             
              <span v-if="row3.item.CountmainManifestationData <= 0">
                <b-button size="sm" variant="outline-danger">Pending</b-button>
              </span>
              <!-- v-else-if="(row3.item.fclAlertId!='' && row3.item.fclAlertId!='null')" -->
              
              <span
                v-else-if="row3.item.CountmainManifestationData > 0"
                variant="success"
              >
                <b-button
                  @click="sendMANIFESTATION(row3.item)"
                  size="sm"
                  variant="success"
                  >Received</b-button
                >
              </span>
               <b-badge variant="danger" v-if="row3.item.newManiFestCount>0"><b>New Manifestation {{row3.item.newManiFestCount}}</b><br/></b-badge
                >
            </template>
            <template slot="closed" slot-scope="row3">
              <span v-if="row3.item.closedOverseas_status == 1">
                <b-button
                  @click="openCloseOverseasModal(row3.item)"
                  size="sm"
                  class="mb-1"
                  variant="outline-danger"
                  >Close</b-button
                >
              </span>
              <span v-else-if="row3.item.closedOverseas_status == 0" variant="success">
                <b-button size="sm" variant="success">Closed</b-button><br />
                User:{{ row3.item.closedOverseas_byuser }}<br />
                Date:{{ row3.item.closedOverseas_created_at }}
              </span>
              <span v-for="(CDitem, CD_index) in row3.item.NoteDetails" :key="CD_index">
                <EditCRDRNote
                  v-if="
                    $sessionsStorage.get('designation') == 'Admin' &&
                    $sessionsStorage.get('nameUser') == 'Bhavneesh' &&
                    CDitem.noteSeries
                  "
                  :title="
                    'Edit ' +
                    (CDitem.creditDebitNoteType === '2' ? 'Debit' : 'Credit') +
                    ' Note : ' +
                    CDitem.noteSeries
                  "
                  :note_id="CDitem.note_id"
                  :noteSeries="CDitem.noteSeries"
                  :note_page="CDitem.page"
                  :AgentType="CDitem.agentType"
                  :creditDebitNoteType="CDitem.creditDebitNoteType"
                  :approvalStatus="CDitem.approvalStatus"
                  :uploadCreditDebit="CDitem.uploadCreditDebit"
                  :creditDebitNote_Status="CDitem.creditDebitNote_Status"
                  :JOBID="row3.item.allModuleId"
                  :JOBNO="row3.item.ffExportFclSeries"
                  :JOBDATE="row3.item.loginTime"
                  :JOBTYPE="row3.item.jobType"
                />
              </span>
              <CommonOverseaUnLock
                v-if="row3.item.closedOverseas_status == '0'"
                :title="'Open Overseas FCL Assignment'"
                :Overlock_item="row3.item"
                :Overlock_JOBNO="row3.item.ffExportFclSeries"
                :Overlock_allModuleId="row3.item.allModuleId"
                :Overlock_table_name="'frght_ffexportfcl'"
                :Overlock_table_key="'ffExportFclId'"
                :Overlock_table_value="row3.item.ffExportFclId"
                :Overlock_column_key="'closedOverseas_status'"
                :Overlock_column_value="row3.item.closedOverseas_status"
                :Overlock_module_type="'Overseas FCL Freight Forwarding'"
              />
              <!-- :Overlock_Function="viewFFExportFCL('0', '0', '1', '1')" -->
              <Add-Message
                :fk_all_module_id="row3.item.allModuleId"
                :fk_client_id="row3.item.clientId"
                :fk_pod_id="row3.item.PODLocationId"
                style="list-style-type: none"
              />
            </template>
          </b-table>
        </div>
        <h5>
          <b-row>
            <b-col md="12" class="my-1">
              <b-pagination
                limit="5"
                align="center"
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                @change="onPageChange($event)"
              ></b-pagination>
            </b-col>
          </b-row>
        </h5>
      </b-card-text>
    </b-card>
    <b-modal id="modal-multi-3" hide-footer ref="confirmModal" title="Confirmation">
      <p class="my-1">
        {{
          mergeModal.actionType == "2"
            ? "Are you sure you want to Split this Assignment..!"
            : "Are you sure you want to Merge containers of this Assignment to selected Assignment..!"
        }}
      </p>
      <div>
        <b-button
          class="mt-3 pull-right"
          variant="outline-danger"
          @click="closeDialogConfirm"
          >Cancel & Close</b-button
        >
        <b-button
          class="mt-3"
          :disabled="isLoading == true ? true : false"
          variant="outline-primary"
          @click="onCloseSubmit"
          >Yes</b-button
        >
      </div>
    </b-modal>
    <div>
      <b-modal
        size="xl"
        no-close-on-esc
        no-close-on-backdrop
        scrollable
        id="myDIV"
        hide-footer
        ref="splitMergePop"
        :title="
          mergeModal.actionType == '2'
            ? 'Assignment Split Utility'
            : 'Assignment Merge Utility'
        "
      >
        <div class="d-block text-center">
          <b-card>
            <b-card-text>
              <div>
                <!-- <md-layout md-gutter class="labelMargtop">
                  <md-layout md-flex="5"></md-layout>

                  <md-layout md-flex="40">
                    <label>Client Name</label>
                    <model-list-select
                      @input="getSplitMergeData"
                      :list="clientList"
                      id="clientId"
                      v-model="mergeModal.clientId"
                      option-value="clientId"
                      option-text="clientName"
                      placeholder="Select Client "
                    ></model-list-select>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="45">
                    <label>Assignment No.</label>
                    <model-list-select
                      :isDisabled="mergeModal.clientId==''"
                      @input="dataOnFromAssignment"
                      :list="assigmnmentList"
                      id="clientId"
                      v-model="mergeModal.ffExportFclId"
                      option-value="ffExportFclId"
                      option-text="ffExportFclSeries"
                      placeholder="Select Assignment "
                    ></model-list-select>
                  </md-layout>
                </md-layout>-->
                <md-layout md-gutter>
                  <md-layout md-flex="20">
                    <label>Action</label>
                    <model-list-select
                      isDisabled
                      @input="getSplitAssignment"
                      :list="actionList"
                      id="actionType"
                      v-model="mergeModal.actionType"
                      option-value="aV"
                      option-text="aT"
                      placeholder="Select Action "
                    ></model-list-select>
                  </md-layout>
                  <md-layout md-flex="5"></md-layout>
                  <md-layout md-flex="75" v-if="mergeModal.actionType == '2'">
                    <label>Assignment No.</label>
                    <model-list-select
                      @input="getTomergeExecId"
                      :list="
                        mergeModal.actionType == '1'
                          ? toMergeAssignmentList
                          : dummySplitAssignment
                      "
                      id="clientId"
                      v-model="mergeModal.ffExportFclIdContainer"
                      option-value="ffExportFclId"
                      option-text="ffExportFclSeries"
                      placeholder="Select Assignment "
                    ></model-list-select>
                  </md-layout>
                </md-layout>
                <div class="gutr" fluid v-if="mergeModal.actionType == '1'">
                  <!-- User Interface controls -->
                  <b-row>
                    <b-col md="12" class="my-1">
                      <b-form-group>
                        <b-input-group>
                          <b-form-input
                            :formatter="capitalizeAll"
                            v-model="filter1"
                            placeholder="Type To Search"
                          />
                          <b-input-group-append>
                            <b-button :disabled="!filter1" @click="filter1 = ''"
                              >Clear</b-button
                            >
                          </b-input-group-append>
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <!-- Main table element -->
                  <b-table
                    responsive
                    bordered
                    show-empty
                    stacked="md"
                    :items="toMergeAssignmentList"
                    :fields="fields1"
                    :current-page="currentPage1"
                    :per-page="perPage1"
                    :filter="filter1"
                    :sort-by.sync="sortBy1"
                    :sort-desc.sync="sortDesc1"
                    :sort-direction="sortDirection1"
                    @filtered="onFiltered1"
                  >
                    <template slot="ffExportFclId" slot-scope="row0">
                      <span>{{ row0.index + 1 + (currentPage1 - 1) * perPage1 }}</span>
                    </template>
                    <template slot="loginTime" slot-scope="row1">
                      <b-form-radio
                        :disabled="containerList.length > 0 ? true : false"
                        @change="onRadioMerge(row1.item.ffExportFclId)"
                        v-model="mergeModal.ffExportFclIdContainer"
                        name="some-radios"
                        :value="row1.item.ffExportFclId"
                        >Select</b-form-radio
                      >
                    </template>
                  </b-table>

                  <b-row>
                    <b-col md="12" class="my-1">
                      <b-pagination
                        limit="25"
                        :total-rows="totalRows1"
                        :per-page="perPage1"
                        v-model="currentPage1"
                        class="my-0 pull-right"
                      />
                    </b-col>
                  </b-row>
                </div>
                <hr class="hr-s" />
                <div class="box" v-if="FFExportContainers.length > 0">
                  <!-- <div class="box-header">
                      <h3 class="box-title"></h3>
                  </div>-->
                  <!-- /.box-header -->

                  <div class="box-body gutr">
                    <table id="po" class="table table-bordered">
                      <thead>
                        <tr>
                          <th>Sr no</th>
                          <!-- <th>Assignment No.</th> -->
                          <th>Container No.</th>
                          <th>Net Weight</th>
                          <th>Gross Weight</th>
                          <th>Custom Seal No.</th>
                          <th>Line Seal No.</th>
                          <th>Select</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          :style="item1.seenExec == '0' ? 'color:red' : 'color:black'"
                          v-for="(item1, index) in FFExportContainers"
                          :key="index"
                        >
                          <td>{{ index + 1 }}</td>

                          <!-- <td>{{item1.ffExportFclSeries}}</td> -->
                          <td>
                            <span>Container No. :</span>
                            <span class="mainClick">{{ item1.containerNo }}</span>
                            <br />
                            <span>Container Type :</span>
                            <span class="mainClick">{{ item1.containerType }}</span>
                          </td>
                          <td>{{ item1.netWeight }}{{ item1.weightUnit }}</td>
                          <td>{{ item1.grossWeight }}{{ item1.weightUnit }}</td>
                          <td>{{ item1.customSealNo }}</td>
                          <td>{{ item1.LineSealNo }}</td>
                          <td>
                            <md-checkbox
                              class="md-primary"
                              style="margin: 0px"
                              :disabled="
                                mergeModal.actionType == '1' &&
                                mergeModal.ffExportFclIdContainer == ''
                                  ? true
                                  : false
                              "
                              @change="getMergeContainerData(item1, index)"
                              v-bind:class="
                                mergeFclContainers.indexOf(item1.ffExportFclId) >= 0
                                  ? 'md-checked checkedNew' +
                                    item1.ffExportFclId +
                                    (index + 1)
                                  : 'checkedNew' + item1.ffExportFclId + (index + 1)
                              "
                              :md-value="item1.ffExportFclId"
                              :name="'deptMas' + (item1.ffExportFclId + 1)"
                              :id="'deptMas' + (item1.ffExportFclId + 1)"
                            ></md-checkbox>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="gutr">
                    <b-button
                      :disabled="
                        containerList.length <= 0 ||
                        (FFExportContainers.length <= 1 && mergeModal.actionType == '2')
                      "
                      variant="primary"
                      class="pull-right ml-2"
                      @click="mergeSubmit"
                      >Submit</b-button
                    >
                    <b-button
                      variant="outline-danger"
                      class="pull-right"
                      @click="closeMerge"
                      >Close</b-button
                    >
                  </div>

                  <!-- /.box-body -->
                </div>
              </div>
            </b-card-text>
          </b-card>
        </div>
      </b-modal>
    </div>
    <div>
      <b-modal
        size="xl"
        id="doc"
        class="modal-dialog-doc"
        no-close-on-esc
        no-close-on-backdrop
        ref="doc-modal"
        hide-footer
        :title="'Assignment Summary & Documents - ' + JOBSERIES"
      >
        <div v-if="ALLMODULE">
          <doc-form :allModuleIdProp="ALLMODULE" :JOBSERIES="JOBSERIES" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideDocModal"
          >Close
        </b-button>
      </b-modal>
    </div>

    <!-- Modal Section Start -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="md"
      ref="CloseOverseas-modal"
      hide-footer
      title=""
    >
      <div class="d-block text-center">
        <h3>Are you sure to want close</h3>
      </div>

      <center>
        <span class="center">
          <b-button class="mt-3" variant="success" @click="SaveCloseOverseas"
            >Yes</b-button
          >
          <b-button class="mt-3" variant="danger" @click="hideCloseOverseasModal"
            >No</b-button
          >
        </span>
      </center>
    </b-modal>
    <!-- Modal Section End -->

    <!-- Added By Priyanshu SIngh STart -->
    <b-modal
      no-close-on-esc
      no-close-on-backdrop
      size="xl"
      ref="note-modal"
      hide-footer
      :title="
        noteModal.creditDebitNoteType == '1'
          ? 'CREDIT NOTE - ' + noteModal.ffExportFclSeries
          : 'DEBIT NOTE - ' + noteModal.ffExportFclSeries
      "
    >
      <div class="d-block text-center">
        <h4 class="error">
          {{
            noteModal.approvalStatus == "1"
              ? "Approved"
              : noteModal.sentForApproval == "1"
              ? "Sent for approval"
              : ""
          }}
        </h4>
      </div>
      <b-row>
        <b-col cols="11" style="text-align: end">
          <!-- {{ noteModal }} -->
          <b-button
            v-if="noteModal.uploadCreditDebit != '' && noteModal.approvalStatus == '1'"
            @click="PrintNote(noteModal.uploadCreditDebit)"
            size="sm"
            variant="warning"
            >PDF</b-button
          >
          <b-button @click="addContent" size="sm"
            >Add Particulars <i class="fa fa-plus-circle ml-1"></i
          ></b-button>
        </b-col>
        <b-col cols="12 text-center">
          <span v-if="noteModal.creditcount >= 1 && noteModal.creditDebitNoteType == '1'"
            ><span class="error">Credit Note No. : </span
            >{{ noteModal.creditnoteSeriesDetailsCount }}</span
          >
          <span v-if="noteModal.debitcount >= 1 && noteModal.creditDebitNoteType == '2'"
            ><span class="error">DEBIT Note No. : </span
            >{{ noteModal.debitnoteSeriesDetailsCount }}</span
          >
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="4" class="mt-2">
          <label for="blType">Type <span class="error">*</span></label>

          <model-list-select
            :list="agentTypeList"
            option-value="TypeVal"
            option-text="TypeTxt"
            v-model="noteModal.agentType"
            placeholder="Select Type"
            @input="getAgentConsigneeList(noteModal.agentType)"
          ></model-list-select>
          <span class="error" v-if="!noteModal.agentType">{{
            errorCDNote.agentType
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="blType">To <span class="error">*</span></label>
          <!-- getAllAgentColoaderList
:list="AgentColoaderList" -->
          <model-list-select
            :list="getAllAgentColoaderList"
            option-value="agentName"
            option-text="agentName"
            v-model="noteModal.AgentColoader"
            :placeholder="
              noteModal.agentType == 'Consignee'
                ? 'Select Consignee'
                : 'Select Agent/Coloader'
            "
            @input="getConsigneeAgentDetails"
          ></model-list-select>
          <span class="error" v-if="!noteModal.AgentColoader">{{
            errorCDNote.AgentColoader
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2" v-if="noteModal.agentType == 'Consignee'">
          <label for="Consignee Address">
            Consignee Address
            <span class="error"></span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.agentconsigneeAddress"
            type="text"
            placeholder="Enter Consignee Address"
          ></b-form-input>
          <span class="error" v-if="!noteModal.agentconsigneeAddress">{{
            errorCDNote.agentconsigneeAddress
          }}</span>
        </b-col>
          <b-col cols="4" class="mt-2" v-if="noteModal.agentType == 'Agent'">
          <label for="Agent Country">
            Agent Country
            <span class="error"></span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.agent_country"
            type="text"
            placeholder="Enter Agent Country"
          ></b-form-input>
          <span class="error" v-if="!noteModal.agent_country">{{
            errorCDNote.agent_country
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="Vessel/Voy">
            Vessel/Voy
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.vesselVoy"
            type="text"
            placeholder="Enter Vessel Voy"
          ></b-form-input>
          <span class="error" v-if="!noteModal.vesselVoy">{{
            errorCDNote.vesselVoy
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="HBL/AWB">
            HBL/AWB
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.house_bl_no"
            type="text"
            placeholder="Enter HBL/AWB"
          ></b-form-input>
          <span class="error" v-if="!noteModal.house_bl_no">{{
            errorCDNote.house_bl_no
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="MBL/MAWB">
            MBL/MAWB
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.master_bl_no"
            type="text"
            placeholder="Enter MBL/MAWB"
          ></b-form-input>
          <span class="error" v-if="!noteModal.master_bl_no">{{
            errorCDNote.master_bl_no
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="SHIPPER">
            SHIPPER
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.clientName"
            type="text"
            placeholder="Enter SHIPPER"
          ></b-form-input>
          <span class="error" v-if="!noteModal.clientName">{{
            errorCDNote.clientName
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="CONSIGNEE">
            CONSIGNEE
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.consignee"
            type="text"
            placeholder="Enter CONSIGNEE"
          ></b-form-input>
          <span class="error" v-if="!noteModal.consignee">{{
            errorCDNote.consignee
          }}</span>
        </b-col>

        <b-col cols="4" class="mt-2">
          <label for="Destination">
            Destination
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.FPOD"
            type="text"
            placeholder="Enter Destination"
          ></b-form-input>
          <span class="error" v-if="!noteModal.FPOD">{{ errorCDNote.FPOD }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="Container No">
            Container No.
            <span class="error">*</span>
          </label>
          <b-form-input
            disabled
            :formatter="capitalizeAll"
            v-model="noteModal.containerNoArryNote"
            type="text"
            placeholder="Enter Container No"
          ></b-form-input>
          <span class="error" v-if="!noteModal.containerNoArryNote">{{
            errorCDNote.containerNoArryNote
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="Container Type">
            Container Type
            <span class="error">*</span>
          </label>
          <b-form-input
            disabled
            :formatter="capitalizeAll"
            v-model="noteModal.containersTypes"
            type="text"
            placeholder="Enter Container Type."
          ></b-form-input>
          <span class="error" v-if="!noteModal.containersTypes">{{
            errorCDNote.containersTypes
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="SHIPPER INV.">
            SHIPPER INV.
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.ShipperInvDet"
            type="text"
            placeholder="Enter SHIPPER INV. Details"
          ></b-form-input>
          <span class="error" v-if="!noteModal.ShipperInvDet">{{
            errorCDNote.ShipperInvDet
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="Booking No">
            Booking No
            <span class="error">*</span>
          </label>
          <b-form-input
            :formatter="capitalizeAll"
            v-model="noteModal.validBookingNo"
            type="text"
            placeholder="Enter Booking No"
          ></b-form-input>
          <span class="error" v-if="!noteModal.validBookingNo">{{
            errorCDNote.validBookingNo
          }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="SOB">
            SOB
            <span class="error">*</span>
          </label>

          <date-picker
            :format="selectDateFormat"
            lang="en"
            id="SOB"
            :minute-step="1"
            name="SOB"
            v-model="noteModal.SOB"
          ></date-picker>
          <span class="error" v-if="!noteModal.SOB">{{ errorCDNote.SOB }}</span>
        </b-col>
        <b-col cols="4" class="mt-2">
          <label for="ETADest">
            ETA Dest
            <span class="error">*</span>
          </label>
          <date-picker
            :format="selectDateFormat"
            lang="en"
            id="ETADest"
            :minute-step="1"
            name="ETADest"
            v-model="noteModal.ETADest"
          ></date-picker>
          <span class="error" v-if="!noteModal.ETADest">{{ errorCDNote.ETADest }}</span>
        </b-col>
        <b-col cols="12">
          <label for="jj">Remarks</label>
          <b-form-textarea
            :formatter="capitalizeAll"
            v-model="noteModal.remarks"
            rows="3"
          ></b-form-textarea>
        </b-col>
        <b-col cols="12">
          <table class="table table-sm table-bordered mt-2">
            <tbody style="background: white">
              <tr v-if="noteParticulars.length > 0">
                <th scope="col" style="width: 5px">SN.</th>
                <th scope="col" style="width: 600px">Particulars</th>
                <th scope="col" style="width: 600px">QTY</th>
                <th scope="col" style="width: 180px">Amount</th>
                <th scope="col" style="width: 180px">Final</th>
                <th scope="col" style="width: 180px">Selected Cont</th>
                <th scope="col" style="width: 180px">Currecny</th>
                <th scope="col" style="width: 5px">Actions</th>
              </tr>
              <tr v-for="(item, index) in noteParticulars" :key="index">
                <th scope="row">{{ index + 1 }}.</th>
                <td>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="item.parti"
                    placeholder="Enter Particular"
                  ></b-form-input>
                </td>
                 <td>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="item.qty"
                    placeholder="Enter Quantity"
                    @input="TotalAMT"
                  ></b-form-input>
                </td>
                <!-- <td>{{ item.qty }}</td> -->
                <td>
                  <b-form-input
                    :formatter="capitalizeAll"
                    v-model="item.amt"
                    type="number"
                    placeholder="Enter Amount"
                    v-on:keyup="TotalAMT"
                  ></b-form-input>
                </td>
                <td>{{ item.final_amt }}</td>
                <td>{{ item.container_selected }}</td>
                <td>
                  <model-list-select
                    :list="CurrencyList"
                    v-model="item.currency"
                    option-value="currency_id"
                    option-text="currencyCode"
                    placeholder="Select Currency"
                  ></model-list-select>
                </td>
                <td>
                  <b-button size="sm" @click="removeParti(index)">
                  <!-- <b-button v-if="index > 0" size="sm" @click="removeParti(index)"> -->
                    <i class="fa fa-minus-circle" aria-hidden="true"></i>
                  </b-button>
                </td>
              </tr>
              <tr v-if="TotAMT != 0">
                <td colspan="2">
                  <b style="color: blue; font-weight: bold; font-size: 18px">Total</b>
                </td>
                <td colspan="3">
                  <b style="color: blue; font-weight: bold; font-size: 18px">{{
                    TotAMT
                  }}</b>
                </td>
              </tr>
            </tbody>
          </table>
        </b-col>
        <b-col cols="12" class="text-center">
          <b-button
            :disabled="IsCDNotedisabled"
            class="mt-3"
            variant="success"
            v-if="noteParticulars.length > 0 && noteModal.AgentColoader"
            @click="submitNote"
            >Send for approval</b-button
          >
          <b-button class="mt-3" variant="outline-danger" @click="hideNoteModal"
            >Close</b-button
          >
        </b-col>
      </b-row>
    </b-modal>
    <b-modal
      id="modal-lock-conf"
      ref="modal-lock-conf"
      title="Reason for Open Locked Assignment"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
    >
      <h3>Confirmation</h3>
      <form ref="form">
        <b-form-group
          label="Remark"
          label-for="name-input"
          invalid-feedback="Name is required"
        >
          <b-form-textarea
            :formatter="capitalizeAll"
            rows="5"
            id="name-input"
            v-model="lockReason"
            required
          ></b-form-textarea>
        </b-form-group>
      </form>
      <b-button @click="closeLockUnLockConfirm" variant="danger"> Cancel</b-button>
      <b-button
        v-if="lockReason"
        :disabled="lock_button ? true : false"
        variant="success"
        class="pull-right"
        @click="ConfLock"
        >Send</b-button
      >
    </b-modal>
    <!-- Added By Priyanshu SIngh End -->

    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      @close="onCloseSubmit"
      ref="addPopSubmit"
    ></md-dialog-confirm>
    <md-dialog-confirm
      :md-content-html="alert.content"
      :md-ok-text="alert.ok"
      ref="addPop"
    ></md-dialog-confirm>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { ModelListSelect } from "vue-search-select";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat, wordWrap } from "../../helper/filters";
import { globalPermissionStatus, lastVisitPage } from "../../helper/collection";
import DocForm from "../../component/allModuleForm/docLibrary.vue";
import FilterAgencyModal from "../allModuleForm/filterAgencyModal.vue";
import FilterCBModal from "../allModuleForm/filterCBModal.vue";
import ClientCard from "../common/clientCard.vue";
import ShipmentTrackCard from "../common/ShipmentTrackCard.vue";
import AddMessage from "../allModuleForm/addMessage.vue";
import AssignmentSummary from "../common/assignmentSummary.vue";
import CommonOverseaUnLock from "../common/commonOverseaUnLock.vue";
import EditCRDRNote from "../common/editCRDRNote.vue";
import ContainerSummary from "../common/moduleBasedContaierSummary.vue";
import JobWisePaymentsDetails from "../common/jobWisePaymentsDetails.vue";
import RejectInvTallyBillSummary from "../common/moduleBasedRejectInvTallyBillSummary.vue";

export default {
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    // if (globalPermissionStatus("Sea Freight")) {
    this.$store.dispatch(
      "commonDropdownMaster/setAllAgentDDList",
      JSON.stringify({
        itemCode: "getAgentDDList",
        type: "Normal",
      })
    );
    this.$store.dispatch("common/setAllAgentColoaderList");
    this.$store.dispatch(
      "common/setAllConsigneeList",
      JSON.stringify({
        itemCode: "ConsigneeList",
      })
    );
    if (globalPermissionStatus("Overseas Agent Assignments")) {
      this.$store.dispatch("setCurrentRoute", "/freightForward/ViewffExportFcl");
      // this.$store.dispatch("setCurrentRoute","/overseas/Viewfright");
      if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
        this.fetchLastPage(this.lastVisitPage);
      } else {
        this.viewFFExportFCL("0", "0", "1", "1");
      }
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      ExcelBtnName: "Export Overseas Assignment",
      lock_allModuleId: "",
      lock_ffExportFclId: "",
      lock_ffExportFclSeries: "",
      lock_Type: "",
      lockReason: "",
      is_locked: "",
      locked_counter: "",
      lock_button: false,
      // Added By Priyanshu Singh Start
      TotAMT: 0,
      ManifestationParticulars: [],
      IsCDNotedisabled: false,
      NoteData: "",
      errorCDNote: {
        agentType: "",
        AgentColoader: "",
        vesselVoy: "",
        house_bl_no: "",
        master_bl_no: "",
        clientName: "",
        consignee: "",
        FPOD: "",
        containerNoArryNote: "",
        containersTypes: "",
        ShipperInvDet: "",
        validBookingNo: "",
        SOB: "",
        ETADest: "",
      },
      arrayErrorCDNote: [
        {
          agentType: "Please Select Type",
          AgentColoader: "Please Select To",
          vesselVoy: "Please Enter Vessel/Voy ",
          house_bl_no: "Please Enter HBL/AWB",
          master_bl_no: "Please Enter MBL/MAWB",
          clientName: "Please ENter SHIPPER",
          consignee: "Please Enter Consignee",
          FPOD: "Please Enter FPOD",
          containerNoArryNote: "Please Enter Container No.",
          containersTypes: "Please Enter Container Type",
          ShipperInvDet: "Please Enter SHIPPER INV",
          validBookingNo: "Please Enter Booking No",
          SOB: "Please Enter SOB",
          ETADest: "Please Enter ETA Destination",
        },
      ],
      selectDateFormat,
      allModuleId: "",
      ShowSendApproval: "",
      AgentColoaderList: [],
      noteParticulars: [],
      CurrencyList: [],
      containerTypeDetailFactory: [],
      note_id: "",
      getCLientData: ["gfdg"],
      agentTypeList: [
        {
          TypeVal: "Consignee",
          TypeTxt: "Consignee",
        },
        {
          TypeVal: "Agent",
          TypeTxt: "Agent",
        },
      ],
      noteModal: {
        agentType: "Agent",
        fk_agent_id: "",
        fk_consignee_id: "",
        agentconsigneeAddress: "",
        agent_country: "",
        shipper: "",
        branchName: "",
        branchList: [],
        AgentColoader: "",
        creditDebitNoteType: "",
        remarks: "",
        noteDate: "",
        note_id: "",
        noteContent: "",
        noteAmount: "",
        noteCurrency: "",
        ffExportFclId: "",
        allModuleId: "",
        fclBlId: "",
        BLNumber: "",
        uploadCreditDebit: "",
        sentForApproval: "",
        approvalStatus: "",
        masterorLinerBlNo: "",
        type: "",

        vesselVoy: "",
        house_bl_no: "",
        master_bl_no: "",
        clientName: "",
        consignee: "",
        FPOD: "",
        containerNoArryNote: "",
        containersTypes: "",
        ShipperInvDet: "",
        validBookingNo: "",
        SOB: "",
        ETADest: "",
      },
      //Added By Priyanshu SIngh End

      overseasClosedItems: "",
      docURL: URL_BASE_DOC,
      ALLMODULE: "",
      JOBSERIES: "",
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      fields: [
        {
          key: "isFFExportActive",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "ffExportFclSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },

        {
          key: "clientName",
          label: "Client / Exporter Name",
          sortable: true,
          sortDirection: "desc",
          class: "text-left colwidth",
        },

        // {
        //   key: "newfreightContainers",
        //   label: "Container",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-left",

        // },
        // {
        //   key: "freightContainersType",
        //   label: "Container Type",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-left",
        // },
        // {
        //   key: "newShipperInv",
        //   label: "Shipper Invoice",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-left",
        // },
        // {
        //   key: "newSB",
        //   label: "Shipping Bill",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-left",
        // },

        {
          key: "POR",
          mainkey: "POR",
          label: "Other",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },
        {
          key: "MBL",
          mainkey: "MBL",
          label: "MBL,HBL/CONTAINERS",
          sortable: true,
          sortDirection: "desc",
          class: "text-left",
        },

        // {
        //   key: "BLNo",
        //   mainkey: "BLNo",
        //   label: "Bl No",
        //   class: "text-left",
        // },

        {
          key: "action",
          mainkey: "action",
          label: "Actions",
          class: "text-left",
        },
        {
          key: "eta_details",
          mainkey: "eta_details",
          label: "ETA Destination Details",
          class: "text-left",
        },
        {
          key: "manifestation",
          mainkey: "manifestation",
          label: "MANIFESTATION",
          class: "text-left",
        },
        {
          key: "closed",
          mainkey: "closed",
          label: "Close",
          class: "text-left",
        },
        // {
        //   key: "invoiceStatus",
        //   mainkey: "invoiceStatus",
        //   label: "Invoice Status",
        //   sortable: true,
        //   sortDirection: "ASC",
        // },
        // {
        //   key: "show_details",
        //   mainkey: "stuffingType",
        //   label: "More Details",
        //   sortable: true,
        //   sortDirection: "ASC",
        // },
        // {
        //   key: "loginTime",
        //   label: "Action",
        //   sortable: true,
        //   sortDirection: "desc",
        //   class: "text-center"
        // }
      ],

      currentPage: 1,
      perPage: 10,
      totalRows: 1000000000000000,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      changePageFilter: "0",
      modalInfo: { title: "", content: "" },
      fields1: [
        {
          key: "ffExportFclId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "ffExportFclSeries",
          label: "Assignment No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "freightContainers",
          label: "Container No.",
          sortable: true,
          sortDirection: "desc",
        },
        {
          key: "loginTime",
          label: "Select Assignment",
          sortable: true,
          sortDirection: "desc",
        },
      ],
      selectedTomerge: "",
      currentPage1: 1,
      perPage1: 2,
      totalRows1: "",
      pageOptions1: [5, 10, 15],
      sortBy1: null,
      sortDesc1: false,
      sortDirection1: "desc",
      filter1: null,
      modalInfo1: { title: "", content: "" },
      filtrActive: 0,
      accounts: globalPermissionStatus("Accounts"),
      freight: globalPermissionStatus("Sea Freight"),
      routePageId: "",
      isLoading: false,
      totalCount: "",
      totalCompleted: "",
      totalVGMSubCount: "",
      totalGateInCount: "",
      totalHandoverCount: "",
      totalRailCount: "",
      totalSailCount: "",
      totalSICount: "",
      totalBLCount: "",
      bookPageId: "",
      execPageId: "",
      vgmPageId: "",
      handoverPageId: "",
      sailPageId: "",
      ladingPageId: "",
      invoiceStatusList: [
        {
          inv: "1",
          int: "In-Progress",
        },
        {
          inv: "2",
          int: "Sent to Accounts",
        },
        {
          inv: "3",
          int: "Billing Not Started",
        },
        {
          inv: "",
          int: "All",
        },
      ],

      blNoStatusList: [
        {
          inv: "1",
          int: "Master BL No",
        },
        {
          inv: "2",
          int: "House BL No",
        },
        {
          inv: "4",
          int: "Only Liner BL No",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      CLosedStatusList: [
        {
          inv: "1",
          int: "Closed",
        },
        {
          inv: "2",
          int: "Pending",
        },
        {
          inv: "3",
          int: "All (Within120 Days)",
        },
        {
          inv: "4",
          int: "Global ALL",
        },
      ],
      ManifestationStatusList: [
        {
          inv: "1",
          int: "Recevied",
        },
        {
          inv: "2",
          int: "Pending",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      SOBStatusList: [
        {
          inv: "1",
          int: "Sailed",
        },
        {
          inv: "2",
          int: "Not Sailed",
        },
        {
          inv: "3",
          int: "All",
        },
      ],
      pageList: [
        {
          inv: "0",
          int: "Old",
        },
        {
          inv: "1",
          int: "New",
        },
      ],
      
      termFilter:"",
      billingFilter: "2",
      ToFilter: "",
      agentFilter:"",
      closedFilter: "2",
      manifestationFilter: "1",
      SOBFilter: "3",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },

      FFExport: [],
      // Modal
      mergeClickCount: "0",
      mergeModal: {
        allModuleId: "",
        splitContainerCount: "",
        splitContainer: "",
        actionType: "",
        noOfContainers: "",
        conTypeIdForEnq: "",
        conTypeForEnq: "",
        mainffId: "",
        clientId: "",
        ffExportFclId: "",
        ffExportFclIdContainer: "",
        toMergeffExecutionId: "",
        mainEnquiryId: "",
        containerTypeIdQuotation: "",
        containerTypeQuotation: "",
        toMergeEnquiryId: "",
        ffShippingWiseId: "",
      },
      actionList: [
        { aV: "1", aT: "Merge" },
        { aV: "2", aT: "Split" },
      ],
      mergeFclContainers: [],
      mergerContainerTypeQuot: [],
      containerCountType: [],
      clientList: [],
      assigmnmentList: [],
      toMergeAssignmentList: [],
      dummySplitAssignment: [],
      showAssignmentTable: false,
      asignmentSeriesCount: "",
      debounce: null,
      showContainerTable: true,
      FFExportContainers: [],
      allClientContainerData: [],
      ffAssignmentQuotation: [],
      countArry: [],
      containerList: [],
      getAllAgentColoaderList: [],
      deliveryTermsList: [
        {
          value: "ExWorks",
          text: "EXWORKS",
        },
        {
          value: "FOB",
          text: "FOB",
        },
        {
          value: "CIF",
          text: "CIF",
        },
        {
          value: "DAP",
          text: "DAP",
        },
        {
          value: "DDU",
          text: "DDU",
        },
        {
          value: "DDP",
          text: "DDP",
        },
        {
          value: "CFR",
          text: "CFR",
        },
        {
          value: "FCA",
          text: "FCA",
        },
      ],
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    // Loading,
    CustomLoader,
    ModelListSelect,
    DocForm,
    FilterAgencyModal,
    FilterCBModal,
    ClientCard,
    ShipmentTrackCard,
    AddMessage,
    AssignmentSummary,
    CommonOverseaUnLock,
    EditCRDRNote,
    ContainerSummary,
    JobWisePaymentsDetails,
    RejectInvTallyBillSummary,
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    sortOptions1() {
      // Create an options list from our fields

      return this.fields1
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
  },
  watch: {
    milestoneFiltersD: {
      handler(newVal, oldVal) {},
      deep: true,
    },
  },
  // props:{
  //   creditNoteStatus(creditNoteStatus) {
  //      alert(creditNoteStatus);
  //      if(creditNoteStatus == 'credit')
  //      {
  //        return true;
  //      }
  //   }
  // },
  methods: {
    ConfLock() {
      if (this.lockReason) {
        this.isLoading = true;
        let tit = "";
        if (this.is_locked == 1) {
          this.is_locked = "0";
          tit = "Un-Locked";
        } else if (this.is_locked == 1) {
          this.is_locked = "1";
          tit = "Locked";
        }
        this.lock_button = true;
        let payload = {
          allModuleId: this.lock_allModuleId,
          lockReason: this.lockReason,
          update_keyVal: this.lock_ffExportFclId,
          assigmnmentSeries: this.lock_ffExportFclSeries,
          Type: this.lock_Type,
          is_locked: this.is_locked,
          locked_counter: this.locked_counter,
          table_name: "frght_ffexportfcl",
          update_key: "ffExportFclId",
          Title: tit,
          module_type: "FF FCL Export",
        };
        // return false;
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/locknnlockStatus.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.find == 1) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.$refs["addPop"].open();
              this.lock_button = false;
              this.viewFFExportFCL("0", "1", "1");
              this.isLoading = false;
            }
            (this.lockReason = ""), this.$refs["modal-lock-conf"].hide();
          })
          .catch((error) => {});
      }
    },
    LockUnLock(items, type) {
      this.lock_allModuleId = items.allModuleId;
      this.lock_ffExportFclId = items.ffExportFclId;
      this.lock_ffExportFclSeries = items.ffExportFclSeries;
      this.lock_Type = type;
      this.is_locked = items.is_locked;
      this.locked_counter = items.locked_counter;
      console.log("Priyanshu Singh=>", items);
      // return false;
      this.$refs["modal-lock-conf"].show();
    },
    closeLockUnLockConfirm() {
      this.$refs["modal-lock-conf"].hide();
    },
    wordWrap,

    checkcreditDebitNote_Status(NoteDetails = []) {
      console.log(
        { NoteDetails },
        (NoteDetails || []).some((x) => x.creditDebitNote_Status == "credit")
      );

      return (NoteDetails || []).some((x) => x.creditDebitNote_Status == "credit");
    },
    creditNoteStatus(creditNoteStatus) {
      //  alert(creditNoteStatus);
      if (creditNoteStatus == "credit") {
        return true;
      }
    },
    PrintNote(ffExportFclSeries, uploadCreditDebit) {
      //  alert(ffExportFclSeries);
      //  alert(uploadCreditDebit);
      let key =
        "ASSIGNMENT_UPLOADS/" +
        ffExportFclSeries.replaceAll("/", "_") +
        "/" +
        uploadCreditDebit;
      this.openSignedDocument(key);
    },
    sendMANIFESTATION(item) {
      // alert(item.fclAlertId);
      // alert(item.allModuleId);
      // alert(item.ffExportFclId);
      // return false;
      this.$sessionsStorage.set("sendManifest_ffFclallModuleId", "");
      this.$sessionsStorage.set("sendManifest_ffFclallModuleId", item.allModuleId);
      this.$sessionsStorage.set("sendManifest_ffExportFclId", item.ffExportFclId);
      this.$router.push({
        path: "/freightForwarding/sendManifestation",
      });
    },
    openCloseOverseasModal(item) {
      console.log("item=>", item);
      this.overseasClosedItems = item;
      this.$refs["CloseOverseas-modal"].show();
    },

    hideCloseOverseasModal() {
      this.$refs["CloseOverseas-modal"].hide();
    },
    SaveCloseOverseas() {
      console.log("overseasClosedItems=>", this.overseasClosedItems);
      // return false;

      let payload = {
        allModuleId: this.overseasClosedItems.allModuleId,
        ffExportFclId: this.overseasClosedItems.ffExportFclId,
        salesSeries: this.overseasClosedItems.ffExportFclSeries,
      };
      //  console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Overseas/sendOverseasCloseRequest1.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      // this.hideCloseOverseasModal();
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "hj");
            this.hideCloseOverseasModal();
            this.viewFFExportFCL("0", "0", "1", "1");
          }
        })
        .catch((error) => {});
    },
    CloseOverses1(item) {
      console.log("ACtions => ", item);

      // if(item.creditDebitNoteType != 1){
      //   this.alert.content ="Are you sure to want close Because of Credit Note Pending ";
      //   this.$refs["addPop"].open();
      // }
      console.log("ACtions => ", item);
      // return false;
      let payload = {
        allModuleId: item.allModuleId,
        ffExportFclId: item.ffExportFclId,
        salesSeries: item.ffExportFclSeries,
      };
      console.log("payload => ", JSON.stringify(payload));
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Overseas/sendOverseasCloseRequest.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "hj");

            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    checkActions(item) {
      console.log("ACtions => ", item);
      // alert(item.ffBookingId)

      this.$sessionsStorage.set("editSalesExId", item.allModuleId);
      this.$sessionsStorage.set("editExportFCLId", item.ffExportFclId);
      this.$sessionsStorage.set("editFFExecutionId", "");
      this.$sessionsStorage.set("editFFBookingId", item.ffBookingId);

      if (item.portLocationType != "USA") {
        this.$router.push({
          path: "/freightForward/BL-NonUS",
        });
      } else {
        this.$router.push({
          path: "/freightForward/BL-US",
        });
      }
    },
    changePage() {
      if (this.changePageFilter == "0") {
        this.$router.push({
          path: "/freightForward/ViewffExportFcl",
        });
      } else {
        this.$router.push({
          path: "/freightForward/newViewffExportFcl",
        });
      }
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.viewFFExportFCL("0", "0", "1", "1");

        // this.typing = null
        // this.message = event.target.value
      }, 1000);
    },
    showDocModal(item) {
      this.ALLMODULE = "";
      this.JOBSERIES = "";
      this.ALLMODULE = item.allModuleId;
      this.JOBSERIES = item.ffExportFclSeries;
      console.log(this.ALLMODULE);
      this.$refs["doc-modal"].show();
    },
    hideDocModal() {
      this.$refs["doc-modal"].hide();
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.perPage - this.perPage;
      }
      this.viewFFExportFCL("0", CURRENT, "2", event);
    },
    filterClear() {
      this.filter = "";
      this.viewFFExportFCL("0", "0", "1", "1");
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL("0", CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    goToDoc(ID) {
      this.$router.push({
        path: "/freightForwarding/ffDocListPage/" + ID + "/Export",
      });
    },
    gotToPage(ID) {
      if (ID == "BOOK") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);

        this.$router.push({
          path: "/freightForward/ffBooking",
        });
      } else if (ID == "EXEC") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        if (this.ffExoprtDetail.stuffingType == "factoryStuffing") {
          this.$router.push({
            path: "/freightForward/ffExecution",
          });
        } else {
          this.$router.push({
            path: "/freightForward/ffexecutionWareHouse",
          });
        }
      } else if (ID == "VGM") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        this.$router.push({
          path: "/freightForward/vgmDetail",
        });
      } else if (ID == "HAND") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        this.$router.push({
          path: "/freightForward/handoverToRail",
        });
      } else if (ID == "SAIL") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        this.$router.push({
          path: "/freightForward/sailFPOD",
        });
      } else if (ID == "LADING") {
        this.$sessionsStorage.set("editFFBookingId", this.bookPageId);
        this.$sessionsStorage.set("editFFExecutionId", this.execPageId);
        this.$router.push({
          path: "/freightForward/fclBLofLanding",
        });
      }
    },
    onRadioMerge(id) {
      this.mergeModal.ffExportFclIdContainer = id;
      this.getTomergeExecId();
    },
    onFiltered1(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows1 = filteredItems.length;
      this.currentPage1 = 1;
    },
    // Modal
    getMergeContainerData(item, index) {
      let i = this.mergeFclContainers.indexOf(item);

      // let i = this.mergeFclContainers.findIndex(z => {
      //   return z.ffExecutionContainerId == z.ffExecutionContainerId;
      // });

      // return false;

      if (i >= 0) {
        this.mergeFclContainers.splice(i, 1);
        this.mergerContainerTypeQuot.splice(i, 1);
        this.containerCountType.splice(i, 1);
      } else {
        this.mergeFclContainers.push(item);
        this.mergerContainerTypeQuot.push(item.containerTypeId);
        this.containerCountType.push(item.containerType);
      }

      this.containerList = [];
      this.mergeFclContainers.map((x) => {
        let obj = {
          containerType: x.containerType,
          containerTypeId: x.containerTypeId,
          subtractContainerId: x.ffConId,
          count: 1,
        };

        let arrayCheck = this.containerList.findIndex((y) => {
          return y.containerTypeId == x.containerTypeId;
        });
        if (arrayCheck >= 0) {
          this.containerList[arrayCheck]["count"] =
            this.containerList[arrayCheck]["count"] + 1;
        } else {
          this.containerList.push(obj);
        }
      });

      this.mergeModal["containerTypeIdQuotation"] = this.mergerContainerTypeQuot.join();
      this.mergeModal["containerTypeQuotation"] = this.containerCountType.join();

      this.mergeModal.containerTypeIdQuotation = Array.from(
        new Set(this.mergeModal.containerTypeIdQuotation.split(","))
      ).toString();

      this.mergeModal.containerTypeQuotation = Array.from(
        new Set(this.mergeModal.containerTypeQuotation.split(","))
      ).toString();

      this.mergeModal.conTypeIdForEnq = "," + this.mergeModal.containerTypeIdQuotation;
      this.mergeModal.conTypeForEnq = "," + this.mergeModal.containerTypeQuotation;

      var counts = {};
      this.containerCountType.forEach(function (x) {
        counts[x] = (counts[x] || 0) + 1;
      });

      this.countArry = Object.values(counts);
      this.mergeModal["noOfContainers"] = "," + this.countArry.join();
      this.getTomergeExecId();
    },
    getSplitMergeData(filterIdD) {
      this.routePageId = filterIdD;
      $("#po").DataTable().destroy();
      if (this.mergerContainerTypeQuot.length <= 0) {
        this.FFExportContainers = [];
      }
      this.isLoading = true;
      let payload = {
        view: "view",
        DCfilterId: filterIdD,
        clientId: this.mergeModal.clientId,
        ffExportFclId: this.mergeModal.ffExportFclId,
        ffExportFclIdContainer: this.mergeModal.ffExportFclIdContainer,
        mainEnquiryId: this.mergeModal.mainEnquiryId,
        allModuleId: this.mergeModal.allModuleId,
        containerTypeIdQuotation: this.mergeModal.containerTypeIdQuotation,
        //   actionType: this.mergeModal.actionType
      };
      //  console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/viewMergeContainerTable.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data, "hj");
            if (data.ffExportContainerData.length > 0) {
              this.FFExportContainers = data.ffExportContainerData;
            } else {
              this.FFExportContainers = [];
            }
            if (data.allClientContainerData.length > 0) {
              this.allClientContainerData = data.allClientContainerData;
            } else {
              this.allClientContainerData = [];
            }

            if (data.ffAssignmentQuotation.length > 0) {
              this.ffAssignmentQuotation = data.ffAssignmentQuotation;
            } else {
              this.ffAssignmentQuotation = [];
            }

            this.asignmentSeriesCount = data.asignmentSeriesCount;

            if (data.clientdetail.length > 0) {
              this.clientList = data.clientdetail;
            } else {
              this.clientList = [];
            }
            if (data.fromMergeAssignmentList.length > 0) {
              this.assigmnmentList = data.fromMergeAssignmentList;
            } else {
              this.assigmnmentList = [];
            }

            if (data.toMergeAssignmentList.length > 0) {
              this.toMergeAssignmentList = data.toMergeAssignmentList;

              this.totalRows1 = this.toMergeAssignmentList.length;
              // this.mergeModal.toMergeffExecutionId =
              //   data.toMergeAssignmentList[0].ffExecutionId;
            } else {
              this.toMergeAssignmentList = [];
            }

            // this.JqueryFun();
            this.dataOnFromAssignment();
            this.getSplitAssignment();

            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    getSplitAssignment() {
      if (this.mergeModal.actionType == "2") {
        this.dummySplitAssignment = [];

        let splitArry = this.assigmnmentList.filter((x) => {
          return x.ffExportFclId == this.mergeModal.ffExportFclId;
        });

        if (splitArry.length > 0) {
          this.mergeModal.splitAssignmentSeries =
            splitArry[0].ffExportFclSeries + "/A" + this.asignmentSeriesCount;
          // alert("split");
          let obj = {
            ffExportFclSeries:
              splitArry[0].ffExportFclSeries + "/A" + this.asignmentSeriesCount,
            ffExportFclId: splitArry[0].ffExportFclId,
          };
          this.dummySplitAssignment.push(obj);
          this.mergeModal.ffExportFclIdContainer = this.dummySplitAssignment[0].ffExportFclId;
        }
      }
      // this.viewFFExportFCL();
    },
    dataOnFromAssignment() {
      let EnqIdArry = this.assigmnmentList.filter((x) => {
        return x.ffExportFclId == this.mergeModal.ffExportFclId;
      });
      if (EnqIdArry.length > 0) {
        this.mergeModal.mainEnquiryId = EnqIdArry[0].mainEnquiryId;
        this.mergeModal.allModuleId = EnqIdArry[0].allModuleId;
      }

      // this.getSplitMergeData();
    },
    getTomergeExecId() {
      let dummyExIdArry = this.allClientContainerData.filter((x) => {
        return x.ffExportFclId == this.mergeModal.ffExportFclIdContainer;
      });

      console.log(
        this.mergeModal.ffExportFclIdContainer,
        "ll",
        this.allClientContainerData
      );
      if (dummyExIdArry.length > 0) {
        console.log(dummyExIdArry, "jjjj");
        this.mergeModal.toMergeffExecutionId = dummyExIdArry[0].ffExecutionId;
        if (this.mergeModal.actionType == "2") {
          //  alert("split");
          this.mergeModal.splitAssignmentSeries =
            dummyExIdArry[0].ffExportFclSeries + "/A" + this.asignmentSeriesCount;
        } else {
          this.mergeModal.splitAssignmentSeries = dummyExIdArry[0].ffExportFclSeries;
        }
      }

      let dummyEnqId = this.toMergeAssignmentList.filter((x) => {
        return x.ffExportFclId == this.mergeModal.ffExportFclIdContainer;
      });

      if (dummyEnqId.length > 0) {
        this.mergeModal.toMergeEnquiryId = dummyEnqId[0].mainEnquiryId;
        this.mergeModal.mainffId = dummyEnqId[0].mainffId;
        this.mergeModal.ffShippingWiseId = dummyEnqId[0].ffShippingWiseId;
      }

      if (this.mergeModal.actionType == "1" && this.mergeClickCount == "0") {
        this.getSplitMergeData();
        this.mergeClickCount = 1;
      }
      //
    },
    showSMModal(item, ID) {
      this.FFExportContainers = [];
      this.mergeModal.allModuleId = item.allModuleId;
      if (ID == "S") {
        this.mergeModal.actionType = "2";
      } else {
        this.mergeModal.actionType = "1";
      }

      this.mergeModal.clientId = item.clientId;
      this.mergeModal.ffExportFclId = item.ffExportFclId;

      this.dataOnFromAssignment(item.ffExportFclId);
      // this.mergeModal.mainEnquiryId=item.,

      this.$refs["splitMergePop"].show();
      this.getSplitMergeData();
    },

    mergeSubmit() {
      this.getSplitMergeData();
      this.$refs["confirmModal"].show();
    },
    closeMerge() {
      this.mergeModal.FFExportContainers = [];

      this.mergeModal.ffExportFclIdContainer = "";
      this.mergeFclContainers = [];
      this.toMergeAssignmentList = [];
      this.containerList = [];
      this.$refs["splitMergePop"].hide();
    },
    closeDialogConfirm() {
      this.mergeFclContainers = [];
      this.containerList = [];
      this.toMergeAssignmentList = [];
      this.mergeModal.ffExportFclIdContainer = "";
      this.$refs["confirmModal"].hide();
      this.$refs["splitMergePop"].hide();

      //this.getSplitMergeData();
    },
    onCloseSubmit() {
      this.mergeModal["containerList"] = this.containerList;

      this.mergeModal.containerList.map((x) => {
        this.mergeModal.splitContainer += x.containerType + ",";
        this.mergeModal.splitContainerCount += x.count + ",";
      });
      // this.isLoading = true;
      this.mergeModal["mergeFclContainers"] = this.mergeFclContainers;
      this.mergeModal["ffAssignmentQuotation"] = this.ffAssignmentQuotation;
      console.log(this.mergeModal);
      // return false;
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/addMergeContainers.php`,
        data: JSON.stringify(this.mergeModal),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.isLoading = false;
            if (data.msg == "Inserted and Updated Successfully") {
              if (this.mergeModal.actionType == "1") {
                this.alert.content = "Container Merged Successfully";
              } else {
                this.alert.content = "Assignment Splited Successfully";
              }
            } else {
              this.alert.content = "Failed To MERGE or SPLIT";
            }
            this.mergeFclContainers = [];
            this.toMergeAssignmentList = [];
            this.mergeModal.ffExportFclIdContainer = "";
            this.containerList = [];
            this.$refs["confirmModal"].hide();

            this.$refs["splitMergePop"].hide();
            this.viewFFExportFCL("0", "0", "1", "1");
            this.$refs["addPop"].open();
          }
        })
        .catch((error) => {});
    },
    // Main Table
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    goToSlinePay(item) {
      this.$sessionsStorage.set("editExportFCLId", item.ffExportFclId);
      if (item.stuffingType == "factoryStuffing") {
        this.$sessionsStorage.set("editFFExecutionId", item.factoryStufExecId);
      } else {
        this.$sessionsStorage.set("editFFExecutionId", item.wareHouseStufExecId);
      }

      this.$router.push({
        path: "/freightForward/ffSLinePaymentExport",
      });
    },
    goToMain() {
      this.$sessionsStorage.set("editExportFCLId", "");
      this.$router.push({
        path: "/freightForward/ffExportFcl",
      });
    },
    JqueryFun() {
      return $(function () {
        return $("#po").DataTable();
      });
    },

    viewExportFCLPage(item) {
      let SEEN = item.seenExec;
      let FCLID = item.ffExportFclId;

      if (SEEN != "1") {
        let paylod = {
          UpdateNotSeenToSeen: "yes",
          ffExportfclId: FCLID,
        };

        let options = {
          method: "POST",
          url: `${URL_BASE}/updateExecutionToSeenAllModules.php`,
          data: JSON.stringify(paylod),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
            }
          })
          .catch((error) => {});
      }

      if (item.newContainerFlow == "1") {
        this.$sessionsStorage.set("editExportFCLId", FCLID);
        this.$router.push({
          path: "/freightForward/newffExportFcl",
        });
      } else {
        this.$sessionsStorage.set("editExportFCLId", FCLID);
        this.$router.push({
          path: "/freightForward/ffExportFcl",
        });
      }
    },
    getReports(id, filterIdD, CURRENT, SEARCH, pageNumber, btnName) {
      //this.isLoading = true;
      let excelIdGivin = "";
      if (id == "OVERSEAS_SCREEN") {
        excelIdGivin = "OVERSEAS_SCREEN";
      } else if (id == "OVERSEAS_SCREEN_ALL") {
        excelIdGivin = "OVERSEAS_SCREEN_ALL";
      }
      let view_Assignment = {
        excelId: excelIdGivin,
        view: "view",
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        termFilter: this.termFilter,
        billingFilter: this.billingFilter,
        closedFilter: this.closedFilter,
        ToFilter: this.ToFilter,
        agentFilter:this.agentFilter,
        manifestationFilter: this.manifestationFilter,
        SOBFilter: this.SOBFilter,
        newContainerFlow: "0",
        assignmentNo: "assignmentNo",
      };
      this.ExcelBtnName = "Downloading Please Wait...";
      console.log(view_Assignment);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Reports/reportsExcel_NewV3.php`,
        data: JSON.stringify(view_Assignment),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };

      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.excelName != undefined) {
              this.ExcelBtnName = btnName;
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },
    viewFFExportFCL(filterIdD, CURRENT, SEARCH, pageNumber) {
      this.mergeFclContainers = [];
      this.containerList = [];
      this.toMergeAssignmentList = [];
      this.mergeModal.ffExportFclIdContainer = "";
      this.filtrActive = filterIdD;
      this.routePageId = filterIdD;

      this.isLoading = true;
      let payload = {
        view: "view",
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,
        termFilter: this.termFilter,
        billingFilter: this.billingFilter,
        closedFilter: this.closedFilter,
        ToFilter: this.ToFilter,
        agentFilter:this.agentFilter,
        manifestationFilter: this.manifestationFilter,
        SOBFilter: this.SOBFilter,
        newContainerFlow: "0",
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/ViewOverseasFcl.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            this.totalRows = data.totalData;
            if (SEARCH != "2") {
              this.currentPage = 1;
              if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
                this.currentPage = parseInt(this.lastVisitPage);
              }
            } else {
              this.currentPage = pageNumber;
            }
            if (data.ffExportDetails.length > 0) {
              this.FFExport = data.ffExportDetails;
            } else {
              this.FFExport = [];
            }
            this.totalCount = data.totalCount ? parseInt(data.totalCount) : 0;
            this.totalCompleted = data.totalCompleted ? parseInt(data.totalCompleted) : 0;
            this.totalVGMSubCount = data.totalVGMSubCount
              ? parseInt(data.totalVGMSubCount)
              : 0;
            this.totalGateInCount = data.totalGateInCount
              ? parseInt(data.totalGateInCount)
              : 0;
            this.totalHandoverCount = data.totalHandoverCount
              ? parseInt(data.totalHandoverCount)
              : 0;
            this.totalRailCount = data.totalRailCount ? parseInt(data.totalRailCount) : 0;
            this.totalSailCount = data.totalSailCount ? parseInt(data.totalSailCount) : 0;
            this.totalSICount = data.totalSICount ? parseInt(data.totalSICount) : 0;
            this.totalBLCount = data.totalBLCount ? parseInt(data.totalBLCount) : 0;
            this.bookPageId = data.SEA_FRGHT_Booking;
            this.execPageId = data.SEA_FRGHT_EXEC;
            this.vgmPageId = data.SEA_FRGHT_VGM;
            this.handoverPageId = data.SEA_FRGHT_RAIL;
            this.sailPageId = data.SEA_FRGHT_SAIL;
            this.ladingPageId = data.SEA_FRGHT_BLADING;
            this.JqueryFun();
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },

    // Added By Priyanshu SIngh Start
    addContent() {
      let obj = {
        parti: "",
        amt: "",
        currency: "1",
        qty:1,
        container_selected:1,
        final_amt:0,
      };
      this.noteParticulars.push(obj);
    },
    removeParti(index) {
      this.noteParticulars.splice(index, 1);
      this.TotalAMT();
    },
    validateCDNote() {
      let validate_new = true;
      Object.keys(this.errorCDNote).map((x, index) => {
        if (this.noteModal[x] == "") {
          this.errorCDNote[x] = this.arrayErrorCDNote[0][x];
          validate_new = false;
        }
      });
      if (validate_new == true) {
        this.validate = true;
      } else {
        this.validate = false;
      }
    },
    removeTags(str) {
      if (str === null || str === "") return false;
      else str = str.toString();
      return str.replace(/(<([^>]+)>)/gi, "");
    },
    getAgentConsigneeList(agentType) {
      this.noteModal.AgentColoader = "";
      if (agentType == "Agent") {
        this.getAllAgentColoaderList = this.$store.getters[
          "common/getAllAgentColoaderList"
        ];
      } else if (agentType == "Consignee") {
        this.getAllAgentColoaderList = this.$store.getters["common/getAllConsigneeList"];
      }
      this.noteModal.AgentColoader = "";
      console.log("AgentColoader Details=>", this.noteModal.AgentColoader);
    },
    getConsigneeAgentDetails() {
      this.noteModal.fk_consignee_id = "";
      this.noteModal.fk_agent_id = "";
      this.noteModal.agentconsigneeAddress = "";
        this.noteModal.agent_country = "";
      if (this.noteModal.agentType == "Consignee") {
        this.getAllAgentColoaderList.forEach((val, ind) => {
          if (val.agentName == this.noteModal.AgentColoader) {
            console.log("Consignee Details=>", val);
            this.noteModal.fk_consignee_id = val.agntColoaderId;
            this.noteModal.agentconsigneeAddress = val.address;
          }
        });
      } else if (this.noteModal.agentType == "Agent") {
        this.getAllAgentColoaderList.forEach((val, ind) => {
          if (val.agentName == this.noteModal.AgentColoader) {
            console.log("Agent Details=>", val);
            this.noteModal.fk_agent_id = val.agntColoaderId;
             this.noteModal.agent_country=val.countryName;
          }
        });
      }
    },
    submitNote() {
      this.validateCDNote();
      if (this.validate == false) return false;

      this.isLoading = true;
      this.ShowSendApproval = false;

      if (this.noteParticulars.length <= 0) {
        this.alert.content = "Please add particulars";
        this.$refs["addPop"].open();
        return false;
      }

      let noteParti = [];
      let noteAmt = [];
      let noteCurrency = [];
      this.noteModal["fk_currency_id"] = "";
      for (let i = 0; i < this.noteParticulars.length; i++) {
        noteParti.push(this.noteParticulars[i].parti);
        noteAmt.push(this.noteParticulars[i].final_amt ? this.noteParticulars[i].final_amt : 0);
        noteCurrency.push(
          this.noteParticulars[i].currency ? this.noteParticulars[i].currency : 0
        );
        this.noteModal["fk_currency_id"] = this.noteParticulars[i].currency
          ? this.noteParticulars[i].currency
          : "1";
      }
      this.noteModal.noteContent = noteParti.toString();
      this.noteModal.noteAmount = noteAmt.toString();
      this.noteModal.noteCurrency = noteCurrency.toString();

      // console.log("NoteData=>",this.NoteData);
      // console.log("noteModal=>", this.noteModal);
      // return false;
      this.noteModal["containerNoArryNote"] = this.NoteData.newfreightContainers;
      this.noteModal["containerTypesArr"] = this.NoteData.containersTypes;
      this.noteModal["ShipperInvDet"] = this.noteModal.ShipperInvDet
        ? this.noteModal.ShipperInvDet
        : this.NoteData.ShipperInvDet;
      this.noteModal["type"] = "FF Export";
      this.noteModal["noteParticulars"] = this.noteParticulars;
      this.noteModal["allModuleId"] = this.NoteData.allModuleId;
      this.noteModal["agentName"] = this.NoteData.agentName;
      this.noteModal["overseas_agent"] = this.NoteData.overseas_agent;
      this.noteModal["agentAddress"] = this.NoteData.agentAddress;
      this.noteModal["vesselVoy"] = this.NoteData.vesselVoy
        ? this.NoteData.vesselVoy
        : this.noteModal.vesselVoy;
      this.noteModal["shipper"] = this.noteModal.clientName
        ? this.noteModal.clientName
        : this.removeTags(this.NoteData.Newconsignor.replaceAll("&nbsp;", " "));
      // this.noteModal["shipper"] = this.NoteData.clientName;
      this.noteModal["consignee"] = this.noteModal.consignee
        ? this.noteModal.consignee
        : this.removeTags(this.NoteData.Newconsignee.replaceAll("&nbsp;", " "));
      this.noteModal.consignee = this.noteModal.consignee ? this.noteModal.consignee : "";
      this.noteModal["fclBlId"] = this.NoteData.fclBlId;
      this.noteModal["branchName"] = this.NoteData.raisedFrom;
      this.noteModal["FinalPlace"] = this.noteModal.FPOD
        ? this.noteModal.FPOD
        : this.NoteData.FPOD;
      this.noteModal["masterorLinerBlNo"] = this.NoteData.master_bl_no
        ? this.NoteData.master_bl_no
        : this.noteModal.master_bl_no;
      this.noteModal["BLNumber"] =
        this.NoteData.billLading +
        (this.NoteData.fclConId != "" ? this.NoteData.fclConId : this.NoteData.fclBlId);
      // this.noteModal["BLNumber"] = this.NoteData.house_bl_no;
      this.noteModal["page"] = "fcl";
      this.noteModal["salesSeries"] = this.NoteData.ffExportFclSeries;
      this.noteModal["salesSeriesUpload"] = this.NoteData.ffExportFclSeries.replaceAll(
        "/",
        "_"
      );
      this.noteModal["ffExportFclId"] =
        this.NoteData.ffExportFclId != ""
          ? this.NoteData.ffExportFclId
          : this.$sessionsStorage.get("editExportFCLId");
      // alert(this.$sessionsStorage.get("editExportFCLId"));
      this.noteModal["LPM"] = this.NoteData.LP;
      this.noteModal["PODM"] = this.NoteData.POD;
      this.noteModal["PORM"] = this.NoteData.POR;
      this.noteModal["clientNameM"] = this.NoteData.clientName;
      this.noteModal["shippingLineM"] = this.NoteData.shippingLine;
      this.noteModal["ASeriesM"] = this.NoteData.ffExportFclSeries;
      this.noteModal["agentNameM"] = this.NoteData.agentName;
      this.noteModal["overseas_agentM"] = this.NoteData.overseas_agent;
      this.noteModal["ASDateM"] = this.NoteData.loginTime;
      this.noteModal["ToM"] = this.NoteData.AgentColoader;
      if (this.noteModal["vesselVoy"] == undefined) {
        this.noteModal["vesselVoy"] = "";
      }

      if (this.noteModal["fclBlId"] == undefined) {
        this.noteModal["fclBlId"] = "0";
      }

      if (this.noteModal["agentAddress"] == undefined) {
        this.noteModal["agentAddress"] = "";
      }

      if (this.noteModal["BLNumber"] == "NaN") {
        this.noteModal["BLNumber"] = "";
      }

      this.noteModal["validBookingNo"] = this.noteModal.validBookingNo
        ? this.noteModal.validBookingNo
        : this.NoteData.validBookingNo;
      this.noteModal["SOB"] = this.noteModal.SOB
        ? this.noteModal.SOB
        : this.NoteData.sob_date_detected;
      this.noteModal["ETADest"] = this.noteModal.ETADest
        ? this.noteModal.ETADest
        : this.NoteData.ETA_destination_estimated;

      this.IsCDNotedisabled = true;
      console.log("this.noteModal=>", this.noteModal);
      // return false;
      if (this.validate != false) {
        console.log(this.noteModal);
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_FFSeaExport/addCreditDebitNoteNew_VP.php`,
          data: JSON.stringify(this.noteModal),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.msg == "Inserted Successfully") {
                this.alert.content = "Data Added Successfully";
              } else {
                this.alert.content = "Data Updated Successfully";
              }
              this.IsCDNotedisabled = false;

              Object.keys(this.noteModal).map((x) => {
                this.noteModal[x] = "";
              });
              this.noteParticulars = [];
              this.$refs["note-modal"].hide();
              this.$refs["addPop"].open();
              // this.getData();
              this.viewFFExportFCL("0", "0", "1", "1");
            }
          })
          .catch((error) => {});
      }
    },
    // PrintNote(ffImportSeries,uploadCreditDebit) {
    //   window.open(
    //     `${this.docURL}/ASSIGNMENT_UPLOADS/` +
    //       ffImportSeries.replaceAll("/", "_") +
    //       "/" +
    //       uploadCreditDebit
    //   );
    // },
    getManifestationParticulars(allModuleId, id) {
      return new Promise((resolve) => {
        this.ManifestationParticulars = [];
        this.noteParticulars = [];
        let noteType = "";
        if (id == "1") {
          noteType = "CREDIT";
        } else if (id == "2") {
          noteType = "DEBIT";
        }
        let payload = {
          noteType: noteType,
          allModuleId: allModuleId,
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Common/getManifestationParticulars.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.manifestationParticulars.length > 0) {
                data.manifestationParticulars.forEach((element) => {
                  let obj = {
                    parti: element.ledgerId,
                    amt: element.amount,
                    currency: element.currency,
                    qty:element.container_count,
                    container_selected:element.container_selected,
                    final_amt:element.container_count*element.amount,
                  };
                  this.noteParticulars.push(obj);
                });
                console.log("manifestationParticulars=>", this.noteParticulars);
              } else {
                this.noteParticulars = [];
              }
              return resolve(this.noteParticulars);
            }
          })
          .catch((error) => {});
      });
    },
    TotalAMT() {
      let TotAmount = 0;
      this.noteParticulars.forEach((value, index) => {
        let amount = 0;
        if (value.qty <= 0) {
          value.qty = 1;
        }
        if (isNaN(value.amt) || value.amt == "") {
          amount = 0;
        } else {
          amount = value.amt * value.qty;
        }
        value.final_amt = value.amt * value.qty;
        if (this.TotAMT == 0) {
          TotAmount = eval(amount);
        } else {
          TotAmount = eval(TotAmount) + eval(amount);
        }
        this.TotAMT = TotAmount;
      });
      console.log("this.totFinalAmount item=>", this.TotAMT);
      this.$forceUpdate();
    },
    getCurrencyList() {
      return new Promise((resolve) => {
        this.CurrencyList = [];
        let payload = {
          Currency: "Currency_DropDown",
        };
        let options = {
          method: "POST",
          url: `${URL_BASE}/Api_Master/viewAllCurrencyList.php`,
          data: JSON.stringify(payload),
          crossDomain: true,
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: this.$sessionsStorage.get("loginId"),
          },
        };
        axios(options)
          .then((result) => {
            const { statusText, status, data } = result;
            if (status == 200 && data) {
              if (data.CurrencyList.length > 0) {
                this.CurrencyList = data.CurrencyList;
              } else {
                this.CurrencyList = [];
              }
              return resolve(this.CurrencyList);
            }
          })
          .catch((error) => {});
      });
    },
    async openNoteModal(id, item) {
      console.log("Modal Item  => ", item);
      this.getAgentConsigneeList(this.noteModal.agentType);
      this.TotAMT = 0;
      let ParticularsArr = await this.getManifestationParticulars(item.allModuleId, id);
      let CurrencyArr = await this.getCurrencyList();
      // alert(ParticularsArr.length);
      if (this.noteParticulars.length > 0) {
        this.TotalAMT();
      }
      this.NoteData = "";
      this.containerTypeDetailFactory = [];
      this.NoteData = item;
      console.log("Priyanshu SIngh=>", item);
      // alert(this.NoteData.exclientName);
      this.noteModal.shipper = this.NoteData.exporterClientId;
      this.noteModal.creditcount = this.NoteData.creditcount;
      this.noteModal.debitcount = this.NoteData.debitcount;
      let creditnoteSeriesDetails = [];
      let debitnoteSeriesDetails = [];
      this.NoteData.NoteDetails.map((NS) => {
        if (NS.creditDebitNoteType == 1) creditnoteSeriesDetails.push(NS.noteSeries);
      });
      this.NoteData.NoteDetails.map((NS) => {
        if (NS.creditDebitNoteType == 2) debitnoteSeriesDetails.push(NS.noteSeries);
      });
      this.noteModal.FPOD = item.FPOD;
      this.noteModal.containerNoArryNote = item.newfreightContainers;
      this.noteModal.containersTypes = item.containersTypes;
      this.noteModal.house_bl_no = item.house_bl_no;
      this.noteModal.master_bl_no = item.MBL;
      this.noteModal.vesselVoy = item.vesselVoy;
      this.noteModal.clientName = item.consignee;
      this.noteModal.AgentColoader = item.agent_coloder_txt;
      this.noteModal.ffExportFclSeries = item.ffExportFclSeries;
      this.noteModal.clientName = this.removeTags(
        item.Newconsignor.replaceAll("&nbsp;", " ")
      );

      this.noteModal.consignee = this.removeTags(
        item.Newconsignee.replaceAll("&nbsp;", " ")
      );
      this.noteModal.clientName = item.Newconsignor ? this.noteModal.clientName : "";
      this.noteModal.consignee = item.Newconsignee ? this.noteModal.consignee : "";
      this.noteModal.ShipperInvDet = item.ShipperInvDet;

      this.noteModal.creditnoteSeriesDetailsCount = creditnoteSeriesDetails.toString();
      this.noteModal.debitnoteSeriesDetailsCount = debitnoteSeriesDetails.toString();

      this.noteModal["validBookingNo"] = item.validBookingNo;
      this.noteModal["SOB"] = item.sob_date_detected ? item.sob_date_detected : item.PSOB;
      this.noteModal["ETADest"] = item.ETA_destination_estimated;
      // this.noteModal.clientName;
      console.log("Single Note Details=>", item);
      console.log("this.NoteData 56=>", this.NoteData);
      // return false;

      this.noteModal.creditDebitNoteType = id;
      this.$refs["note-modal"].show();
      this.getAgentColoaderList();
    },
    hideNoteModal() {
      this.noteModal.approvalStatus = "";
      this.noteModal.sentForApproval = "";
      this.noteContent = "";
      this.noteAmount = "";
      this.noteCurrency = "";
      this.note_id = "";
      this.noteModal.remarks = "";
      this.noteParticulars = [];
      this.$refs["note-modal"].hide();
      this.isLoading = false;
    },
    getAgentColoaderList() {
      let type_Size = {
        view: "jdjd",
      };
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_FFSeaExport/getAgentColoaderList.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options).then((result) => {
        const { statusText, status, data } = result;
        if (status == 200 && data) {
          this.AgentColoaderList = data.agentColoaderList;
        }
      });
    },

    //   wordWrap(str, maxWidth) {
    //     let newLineStr = "\n";
    //     let done = false;
    //     let res = '';
    //     while (str.length > maxWidth) {
    //         let found = false;
    //         // Inserts new line at first whitespace of the line
    //         for (let i = maxWidth - 1; i >= 0; i--) {
    //             if (this.testWhite(str.charAt(i))) {
    //                 res = res + [str.slice(0, i), newLineStr].join('');
    //                 str = str.slice(i + 1);
    //                 found = true;
    //                 break;
    //             }
    //         }
    //         // Inserts new line at maxWidth position, the word is too long to wrap
    //         if (!found) {
    //             res += [str.slice(0, maxWidth), newLineStr].join('');
    //             str = str.slice(maxWidth);
    //         }

    //     }
    //     return res + str;
    // },

    // testWhite(x)
    // {
    //     let white = new RegExp(/^\s$/);
    //     return white.test(x.charAt(0));
    // }
    // Added By Priyanshu SIngh End
  },
};
</script>
<style scoped>
.colwidth {
  min-width: 200px !important;
}
a:not(.md-button):not(.md-bottom-bar-item):hover {
  text-decoration: none !important;
}
</style>



// WEBPACK FOOTER //
// overSeasFreight.vue?a5296776